module.exports = __webpack_public_path__ + "static/img/アセット 21@2x.c6c749d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 21@2x.png
// module id = zUJc
// module chunks = 1